/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function PictureInPicturePreview({ srcs }) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []
  const pictureInPictureSrc =
    validImages[0]?.file instanceof File
      ? URL.createObjectURL(validImages[0].file)
      : validImages[0]?.file || ''

  return (
    <>
      <div
        className="scroller-hide"
        style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      >
        <div className="w-100 pb-1">
          <Image
            className="position-absolute"
            src={mobilePhone}
            style={{ width: '19.5rem', right: '16%', top: '6%' }}
          />
        </div>
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
        </div>

        <div className="position-relative text-ban1">
          {validImages.length > 0 && (
            <>
              <img
                className="position-absolute"
                src={pictureInPictureSrc}
                alt={validImages[0]?.label || 'Picture-in-Picture'}
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: 'auto',
                  left: '0',
                  bottom: '0',
                  position: 'absolute',
                  zIndex: 2,
                }}
              />
              <CIIcon />
            </>
          )}
        </div>
      </div>

      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </>
  )
}

PictureInPicturePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
}

PictureInPicturePreview.defaultProps = {
  srcs: [],
}

export default PictureInPicturePreview
